import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "../useRequest";
import { IUser } from "src/types";

export const useUsers = (query: Record<string, QueryParamsType>) => {
  const url = `/users?${qs.stringify(query)}`;
  const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
  return {
    users: (data as Array<IUser>) || [],
    mutate,
    isLoading,
    error,
    ...rest,
  };
};
